import { Image } from 'expo-image';
import { Pressable, Text, View } from 'react-native';
import RestaurantPlaceholder from '@/components/display/restaurant-placeholder';
import type { Business } from '@/types/business';
import { imageUrl } from '@/utils/image-url';

interface BusinessResultItemProps {
  business: Business;
  onPress: (id: string) => void;
}

export function BusinessResultItem({ business, onPress }: BusinessResultItemProps) {
  return (
    <Pressable
      onPress={() => onPress(business.id)}
      className="mb-4 p-4 rounded-lg bg-surface border border-border"
      style={{ borderCurve: 'continuous' }}
    >
      <View className="flex-row">
        <View className="w-20 h-20 rounded-lg mr-3 overflow-hidden" style={{ borderCurve: 'continuous' }}>
          {business.coverPhotoUrl ? (
            <Image
              source={{ uri: imageUrl(business.coverPhotoUrl, 'thumbnail') }}
              className="w-full h-full"
              contentFit="cover"
              accessibilityLabel={`Photo of ${business.name}`}
            />
          ) : (
            <RestaurantPlaceholder name={business.name} width={80} height={80} />
          )}
        </View>

        <View className="flex-1">
          <Text className="text-lg font-semibold mb-1 text-foreground">
            {business.name}
          </Text>

          <View className="flex-row items-center mb-2">
            {(business.cuisineType || business.tags?.[0]) && (
              <Text className="text-sm mr-2 text-muted-foreground">
                {business.cuisineType || business.tags?.[0]}
              </Text>
            )}
            {(business.city || business.state) && (
              <Text className="text-sm text-muted-foreground">
                {[business.city, business.state].filter(Boolean).join(', ')}
              </Text>
            )}
          </View>

          <Text className="text-xs text-muted-foreground">
            {business.totalRatings > 0 ? `${business.totalRatings} ratings` : 'No ratings yet'}
          </Text>
        </View>
      </View>
    </Pressable>
  );
}
